import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { tradingRulesNodes } from './TradingRulesContent';
import './TradingRulesStyle.css';

const TradingRulesPage: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '圆领平台交易规则';
  }, []);

  return (
    <div className="trading-rules-page">
      <div className="trading-rule policy-wrap">
        {tradingRulesNodes.map((node, index) => {
          if (node.type === 'br') {
            return <br key={index} />;
          }
          if (node.type === 'h1') {
            return (
              <h1 key={index} className="text-align-center">
                {node.text}
              </h1>
            );
          }
          if (node.type === 'h2') {
            return <h2 key={index}>{node.text}</h2>;
          }
          const className =
            node.type === 'p' && /^（20\d{2}/.test(node.text)
              ? 'text-align-center'
              : undefined;
          return (
            <p key={index} className={className}>
              {node.text}
            </p>
          );
        })}
      </div>
    </div>
  );
});

export default TradingRulesPage;
